var React = require('react');

function Sailboat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 16C3 18.8125 6 21 8 21C10 21 15 21 15 21M6.5 16C6.5 16 19.2901 16 20.8939 16C20.9531 16 20.9947 16.0536 20.9883 16.1124C20.4624 21 18 21 18 21","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M12 13V3.57016C12 3.3811 12.2381 3.29759 12.3562 3.44522L19.74 12.6751C19.8448 12.806 19.7516 13 19.5839 13H14.6667","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M9 13H5.34464C5.19107 13 5.0948 12.8341 5.17099 12.7008L9 6","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round","key":2})]);
}

Sailboat.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Sailboat;

Sailboat.default = Sailboat;
